<h1 mat-dialog-title>{{ data.title | translate | titlecase }}</h1>

<div mat-dialog-content>

    <div class="row no-gutters mb-4">
        <div class="col-12">

            <input-text-clipboard [idPrefix]="idPrefix"
                                  [idSuffix]="'system_id'"
                                  [label]="'client.system_id'"
                                  [bananaBox]="clientID"
                                  [readonly]="true">
            </input-text-clipboard>

        </div>
    </div>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-12 no-gutters pl-0 pr-0">
        <button id="{{idPrefix}}btn.close"
                mat-raised-button class="full-width" color="accent"
                (click)="close()">{{ 'common.btn.close' | translate }}
        </button>
    </div>

</div>
